import React from 'react';

export const Tjenester = () => {
  return (
    <main className="grid">

<div className="div-Tjenester">

      <h2 className="div-Tjenester-h2">Mine Kompetencer</h2>

      {/* Webudvikling */}
      <div className="service-card">
        <h3>Webudvikling</h3>
        <p>
          Jeg udvikler moderne og responsivt designede hjemmesider med fokus på funktionalitet, performance og brugeroplevelse.
        </p>
        <ul>
          <li>Design og udvikling af hjemmesider fra bunden</li>
          <li>Redesign og optimering af eksisterende sider</li>
          <li>Responsivt design til mobil, tablet og desktop</li>
          <li>Integration af kontaktformularer og grundlæggende SEO</li>
        </ul>
      </div>

      {/* Mobil-apps */}
      <div className="service-card">
        <h3>Mobil-apps</h3>
        <p>
          Jeg udvikler brugervenlige apps, der optimerer processer og skaber værdi for brugere og virksomheder.
        </p>
        <ul>
          <li>Cross-platform apps til Android og iOS</li>
          <li>Integration med hjemmesider og databaser</li>
          <li>Enkelhed og brugervenlighed i design</li>
          <li>Push-beskeder og notifikationer</li>
        </ul>
      </div>

      {/* Desktop-applikationer */}
      <div className="service-card">
        <h3>Desktop-applikationer</h3>
        <p>
          Jeg bygger brugervenlige desktop-programmer i Java og C# med fokus på datahåndtering og automatisering.
        </p>
        <ul>
          <li>Udvikling af programmer til virksomheder og privatbrug</li>
          <li>Databehandling og rapportgenerering</li>
          <li>Integration med MySQL og MongoDB</li>
          <li>Eksport til Excel, CSV og andre formater</li>
        </ul>
      </div>

      {/* Databaser & Softwarekompetencer */}
      <div className="service-card">
        <h3>Databaser & Softwarekompetencer</h3>
        <p>
          Jeg har erfaring med databaser og programmering, hvilket gør mig klar til en junior softwareudviklerstilling.
        </p>
        <ul>
          <li>Java, C#, HTML, CSS, JavaScript</li>
          <li>Databasehåndtering (MySQL, MongoDB)</li>
          <li>Objektorienteret programmering og kodestandarder</li>
          <li>Udvikling af komplette softwareprojekter fra idé til implementering</li>
        </ul>
      </div>

    </div>

    </main>
    
  );
};
